import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiPhone, FiMail, FiMapPin, FiFacebook, FiLinkedin, FiTwitter, FiInstagram } from 'react-icons/fi';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [settings, setSettings] = useState({});
  useEffect(() => { api.get('/settings').then(r => setSettings(r.data)).catch(() => {}); window.scrollTo(0,0); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); setSubmitting(true);
    try { await api.post('/contact', form); toast.success('Message sent! We\'ll be in touch shortly.'); setForm({ name:'',email:'',phone:'',subject:'',message:'' }); }
    catch { toast.error('Failed to send. Please try again.'); }
    setSubmitting(false);
  };

  return (
    <div style={{ paddingTop: 74 }}>
      <section style={{ background: 'linear-gradient(135deg, #060F1E 0%, var(--navy) 100%)', padding: '5.5rem 0 4rem' }}>
        <div className="container">
          <span className="label" style={{ marginBottom: '1rem', display: 'inline-flex' }}>Reach Out</span>
          <h1 style={{ fontFamily: 'Fraunces, serif', fontSize: 'clamp(2.2rem,4vw,3.2rem)', color: 'white', marginBottom: '1.25rem', lineHeight: 1.15 }}>Let's Start a Conversation</h1>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1.05rem', maxWidth: 520, lineHeight: 1.75 }}>We'd love to hear from you. Our team is available Monday–Friday, 8am–5pm GMT.</p>
        </div>
      </section>

      <section className="section-pad">
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.6fr', gap: '4rem', alignItems: 'start' }}>
            <div>
              <h2 style={{ fontFamily: 'Fraunces, serif', fontSize: '1.4rem', color: 'var(--navy)', marginBottom: '0.5rem' }}>Contact Information</h2>
              <div className="gold-line" style={{ marginBottom: '1.75rem' }} />
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem', marginBottom: '2.5rem' }}>
                {[[<FiPhone />, 'Phone', settings.phone || '+233 24 602 1518', `tel:${settings.phone}`],
                  [<FiMail />, 'Email', settings.email || 'smartqualitygh@gmail.com', `mailto:${settings.email}`],
                  [<FiMapPin />, 'Address', settings.address || 'Vanguard Assurance Building, 1st Floor, Accra, Ghana', null]].map(([icon, label, val, href]) => (
                  <div key={label} style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
                    <div style={{ width: 44, height: 44, background: 'var(--navy)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#C9A84C', flexShrink: 0, fontSize: '1rem' }}>{icon}</div>
                    <div>
                      <div style={{ fontWeight: 600, color: 'var(--navy)', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.2rem' }}>{label}</div>
                      {href ? <a href={href} style={{ color: 'var(--gray-600)', fontSize: '0.92rem' }}>{val}</a> : <span style={{ color: 'var(--gray-600)', fontSize: '0.92rem' }}>{val}</span>}
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ display: 'flex', gap: '0.6rem' }}>
                {[settings.facebook && [FiFacebook, settings.facebook], settings.linkedin && [FiLinkedin, settings.linkedin], settings.twitter && [FiTwitter, settings.twitter], settings.instagram && [FiInstagram, settings.instagram]].filter(Boolean).map(([Icon, href], i) => (
                  <a key={i} href={href} target="_blank" rel="noreferrer" style={{ width: 40, height: 40, background: 'var(--navy)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#C9A84C', fontSize: '1rem', transition: 'background 0.2s' }}
                    onMouseEnter={e => e.currentTarget.style.background = 'var(--gold)'}
                    onMouseLeave={e => e.currentTarget.style.background = 'var(--navy)'}><Icon /></a>
                ))}
              </div>
              {settings.map_embed_url && (
                <div style={{ marginTop: '2rem', borderRadius: '14px', overflow: 'hidden', height: 240 }}>
                  <iframe title="map" src={settings.map_embed_url} width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy" />
                </div>
              )}
            </div>
            <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} style={{ background: 'white', padding: '2.5rem', borderRadius: '24px', boxShadow: 'var(--shadow-lg)', border: '1px solid var(--gray-100)' }}>
              <h2 style={{ fontFamily: 'Fraunces, serif', fontSize: '1.35rem', color: 'var(--navy)', marginBottom: '2rem' }}>Send Us a Message</h2>
              <form onSubmit={handleSubmit}>
                <div className="grid-2">
                  <div className="form-group"><label className="form-label">Full Name *</label><input className="form-input" required value={form.name} onChange={e => setForm({...form, name: e.target.value})} placeholder="your name" /></div>
                  <div className="form-group"><label className="form-label">Email *</label><input className="form-input" type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} placeholder="youremail@gmail.com" /></div>
                </div>
                <div className="grid-2">
                  <div className="form-group"><label className="form-label">Phone</label><input className="form-input" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} /></div>
                  <div className="form-group"><label className="form-label">Subject *</label><input className="form-input" required value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} placeholder="How can we help?" /></div>
                </div>
                <div className="form-group"><label className="form-label">Message *</label><textarea className="form-input" required style={{ minHeight: 150 }} value={form.message} onChange={e => setForm({...form, message: e.target.value})} placeholder="Tell us about your needs..." /></div>
                <button type="submit" className="btn btn-navy" style={{ width: '100%', justifyContent: 'center', fontSize: '0.95rem', padding: '0.9rem' }} disabled={submitting}>
                  {submitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}
